import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}`}>
      <div className={styles.headerContent}>
        <div className={styles.logo}>
          <a href="/" className={styles.logoLink}>
            <img src="/assets/images/logo.svg" alt="Rythm" className={styles.logoImage} />
          </a>
        </div>
        <nav className={styles.navigation}>
          <ul>
            <li>
              <a href="https://discord.gg/ZtH6rZpa8y" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src="/assets/images/discord.svg" alt="Discord" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/rythmfm/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src="/assets/images/instagram.svg" alt="Instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@rythmfm" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <img src="/assets/images/tiktok.svg" alt="TikTok" />
              </a>
            </li>
            <li>
              <a href="https://discord.gg/ZtH6rZpa8y" target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>
                Join Rythm
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 